import React from "react";
import { Helmet } from "react-helmet";
import NewTicketForm from "./newTicketForm";
import HeaderDark from "../../../../components/Header/HeaderDark";
import Address from "../../../../components/Address";
import FooterThreeDark from "../../../../components/Footer/FooterThreeDark";
import CopyRight from "../../../../components/Footer/Copyright/CopyRight";

const NewTicket = () => {
  return (
    <div>
      <Helmet>
        <title>Githubit - Open Ticket</title>
      </Helmet>

      <HeaderDark />

      <div className="ptf-main">
        <div className="ptf-page ptf-page--contact">
          <section>
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
            />

            <div className="container-xxl">
              <div className="row">
                <div className="col-xl-10">
                  <div
                    className="ptf-animated-block"
                    data-aos="fade"
                    data-aos-delay="0"
                  >
                    <h1 className="large-heading text-white">New ticket</h1>
                    <div
                      className="ptf-spacer"
                      style={{ "--ptf-xxl": "3rem", "--ptf-md": "2.5rem" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
            />
          </section>

          <section>
            <div className="container-xxl">
              <div className="row">
                <div className="col-lg-4">
                  <Address />
                </div>

                <div className="col-lg-8">
                  <div
                    className="ptf-animated-block"
                    data-aos="fade"
                    data-aos-delay="300"
                  >
                    <h5 className="fz-14 text-uppercase has-black-color fw-normal">
                      Feel free to describe problem or ideas
                    </h5>
                    <div
                      className="ptf-spacer"
                      style={{ "--ptf-xxl": "3.125rem" }}
                    />
                    <NewTicketForm />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
            />
          </section>
        </div>
      </div>

      <footer className="ptf-footer ptf-footer--style-5">
        <div className="container-xxl">
          <div
            className="ptf-divider"
            style={{
              "--ptf-height": "1px",
              "--ptf-color": "var(--border-color)",
            }}
          />
          <div className="ptf-footer__top">
            <FooterThreeDark />
          </div>

          <div className="ptf-footer__bottom">
            <CopyRight />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewTicket;
